import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const IncomeSheetContext = createContext(null);

export function IncomeSheetProvider({ children }) {
  const [isOpen, setOpen] = useState(false);

  const open = useCallback(() => {
    setOpen(true);
  }, []);

  const close = useCallback(() => {
    setOpen(false);
  }, []);

  const value = useMemo(
    () => ({ isOpen, open, close, setOpen }),
    [isOpen, open, close],
  );

  return (
    <IncomeSheetContext.Provider value={value}>
      {children}
    </IncomeSheetContext.Provider>
  );
}

export function useIncomeSheet() {
  const ctx = useContext(IncomeSheetContext);
  if (!ctx) {
    throw new Error('useIncomeSheet must be used inside <IncomeSheetProvider>');
  }
  return ctx;
}
